module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_010.png
// module id = 2357
// module chunks = 5